export default {
  id: '64534345',
  type: 'social',
  category: 'other',
  content: {
    title: 'follow us',
    services: {
      facebook: {
        name: 'Facebook Share',
        class: 'icon-facebook',
        url: 'https://www.facebook.com',
      },
      instagram: {
        name: 'Instagram Share',
        class: 'icon-instagram',
        url: 'https://www.instagram.com',
      },
      twitter: {
        name: 'Twitter Share',
        class: 'icon-twitter',
        url: 'https://www.twitter.com',
      },
      email: {
        name: 'Email',
        class: 'icon-email',
        url: 'youremail@email.com',
      },
      youtube: {
        name: 'Youtube Share',
        class: 'icon-youtube',
        url: 'https://www.youtube.com',
      },
      linkedin: {
        name: 'Linkedin Share',
        class: 'icon-linkedin',
        url: 'https://www.linkedin.com',
      },
      github: {
        name: 'Github Share',
        class: 'icon-github',
        url: 'https://www.github.com',
      },
      medium: {
        name: 'Medium Share',
        class: 'icon-medium',
        url: 'https://www.medium.com',
      },
      website: {
        name: 'Website',
        class: 'icon-website',
        url: 'https://www.yourwebsite.com',
      },
    },
    // the actual selected services which will be displayed
    selectedServices: ['facebook', 'instagram', 'medium'],
  },
  settings: {},
  // Ex. maxLetters: 0,
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: {
    direction: 'row',
    textAlign: 'center',
    color: 'rgb(24,23,26)',
  },
}
